import * as React from "react";
import { IBillingReport } from "@nkr/models/index";
import { ChargeTypes } from "@nkr/enums/index";
import { Glyphicon, Label } from "react-bootstrap";
import { RowWrapper } from "./styles";

interface IProps {
    data: IBillingReport,
    expanded: boolean,
    onExpand: (id: number, expanded: boolean) => void
}

class ItemRow extends React.Component<IProps, {}> {
    handleExpand = () => {
        this.props.onExpand(this.props.data.donorId, this.props.expanded);
    }

    getClaimType = () => {
        let { isSbs, isMedicare, isMedicaid, isGlobal } = this.props.data

        let claimType = "";

        if (isSbs)
            claimType = "SBS";

        if (isMedicare)
            claimType = "Medicare";

        if (isMedicaid)
            claimType = "Medicaid";

        if (isGlobal)
            claimType = "Global"

        if (!isSbs && !isMedicare && !isMedicaid && !isGlobal)
            return "Non-Global";

        return claimType;
    }

    getChargeAmount = (charges: number, chargeType: ChargeTypes) => {
        let { isSbs, isMedicare, isMedicaid, isGlobal, asaUnitPrice, asaUnits } = this.props.data;

        if (isSbs) {
            // return charges.toLocaleString('en', { minimumFractionDigits: 2 });
            return charges;
        }

        if (isMedicare) {
            // return "Billed through Medicare using recipient Medicare #";
            return 0;
        }

        if (isMedicaid) {
            if (chargeType == ChargeTypes.PHYSICIAN_CHARGES)
                //return "NKR will remit $2,000";
                return 0;
            else
                // return "NKR will remit $1,000";
                return 0;
        }

        if (isGlobal) {
            if (chargeType == ChargeTypes.PHYSICIAN_CHARGES)
                // return charges.toLocaleString('en', { minimumFractionDigits: 2 });
                return charges;
            else
                // return (asaUnitPrice * asaUnits).toLocaleString('en', { minimumFractionDigits: 2 });
                return asaUnitPrice * asaUnits;
        }

        if (!isSbs && !isMedicare && !isMedicaid && !isGlobal) {
            // return "Bill private insurance directly";
            return 0;
        }
    }

    getStatus = () => {
        switch (this.props.data.status) {
            case 10: return "Pending";
            case 15: return "Submitted to Recipient Center";
            case 20: return "Accepted";
            case 30: return "Disputed";
            case 40: return "Invoiced";
            case 50: return "Not Invoiced";
        }
    }

    render = () => {
        const glyphIcon = this.props.expanded ? "triangle-bottom" : "triangle-right";
        const claimType = this.getClaimType();
        const physicianCharges = this.getChargeAmount(this.props.data.physicianCharges, ChargeTypes.PHYSICIAN_CHARGES);
        const anesthesiaCharges = this.getChargeAmount(this.props.data.anesthesiaCharges, ChargeTypes.ANESTHESIA_CHARGES);
        const hospitalCharges = this.props.data.hospitalCharges;
        const claimAmount = (physicianCharges + anesthesiaCharges + hospitalCharges).toLocaleString('en', { minimumFractionDigits: 2 });
        const status = this.getStatus();

        return (
            <>
                <RowWrapper>
                    <td style={{ textAlign: "center" }}>
                        {this.props.data.status == 30 && (
                            <Glyphicon glyph={glyphIcon} onClick={this.handleExpand} />
                        )}
                    </td>
                    <td>{this.props.data.donorCenterAlias}</td>
                    <td>{this.props.data.donorAlias}</td>
                    <td>{this.props.data.donorUnosId}</td>
                    <td>{this.props.data.recipientCenterAlias}</td>
                    <td>{this.props.data.recipientAlias}</td>
                    <td>{this.props.data.chainId}&nbsp;/&nbsp;{this.props.data.clusterNumber}&nbsp;/&nbsp;{this.props.data.positionNumber}</td>
                    <td>{this.props.data.transplantDate}</td>
                    <td>{this.props.data.dateSubmitted}</td>
                    <td>{this.props.data.dateRecipientCenterSubmitted}</td>
                    <td>{claimType}</td>
                    <td>{claimAmount}</td>
                    <td>{status}</td>
                </RowWrapper>

                {this.props.expanded ?
                    <>
                        <tr>
                            <td colSpan={13}>
                                <table className="table table-striped table-condensed" style={{ width: "90%", marginLeft: "auto", marginRight: "auto" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "15%" }}>Item</th>
                                            <th style={{ width: "15%" }}>Amount</th>
                                            <th style={{ width: "20%" }}>Status</th>
                                            <th style={{ width: "50%" }}>Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Physician Charges</td>
                                            <td>{this.props.data.items.physicianCharge}</td>
                                            <td>
                                                {this.props.data.items.physicianChargeStatus == 'Accepted' ?
                                                    <Label bsStyle='success' style={{ fontSize: '100%' }}>{this.props.data.items.physicianChargeStatus}</Label>
                                                    :
                                                    <Label bsStyle='danger' style={{ fontSize: '100%' }}>{this.props.data.items.physicianChargeStatus}</Label>
                                                }
                                            </td>
                                            <td>{this.props.data.items.physicianChargeComments}</td>
                                        </tr>
                                        <tr>
                                            <td>Anesthesia Charges</td>
                                            <td>{this.props.data.items.anesthesiaCharge}</td>
                                            <td>
                                                {this.props.data.items.anesthesiaChargeStatus == 'Accepted' ?
                                                    <Label bsStyle='success' style={{ fontSize: '100%' }}>{this.props.data.items.anesthesiaChargeStatus}</Label>
                                                    :
                                                    <Label bsStyle='danger' style={{ fontSize: '100%' }}>{this.props.data.items.anesthesiaChargeStatus}</Label>
                                                }
                                            </td>
                                            <td>{this.props.data.items.anesthesiaChargeComments}</td>
                                        </tr>
                                        <tr>
                                            <td>Hospital Charges</td>
                                            <td>{this.props.data.items.hospitalCharge}</td>
                                            <td>
                                                {this.props.data.items.hospitalChargeStatus == 'Accepted' ?
                                                    <Label bsStyle='success' style={{ fontSize: '100%' }}>{this.props.data.items.hospitalChargeStatus}</Label>
                                                    :
                                                    <Label bsStyle='danger' style={{ fontSize: '100%' }}>{this.props.data.items.hospitalChargeStatus}</Label>
                                                }
                                            </td>
                                            <td>{this.props.data.items.hospitalChargeComments}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </>
                    : null}
            </>
        );
    }
}

export default ItemRow;